module.exports = __webpack_public_path__ + "static/profile-090a5aabae505f67ee0981613d02ee05.jpg";